import React from 'react';
import { MdArrowBack } from 'react-icons/md';
import { Link } from 'react-router-dom';
import styles from './Header.module.scss';

interface HeaderProps {
  title?: string;
  badge?: {
    label: string;
    active: boolean;
  };
  children?: React.ReactNode;
}
export const Header = ({ badge, title = 'Otimização de preços', children }: HeaderProps) => {
  return (
    <header className={styles.container}>
      <Link className={styles.back} to="/ipa/ia/otimizacao-de-precos/lista">
        <MdArrowBack style={{ height: '24px', width: '24px' }} color="#505050" />
        <span>Voltar para lista de otimizações</span>
      </Link>

      <section className={styles.content}>
        <div className={styles.title}>
          <p>{title}</p>
          {badge?.label ? (
            <span className={styles.badge} data-active={badge?.active}>
              {badge?.label}
            </span>
          ) : null}
        </div>
        {children}
      </section>
    </header>
  );
};
